<template>
  <div>
    <attachment-count-badge
      v-if="valueIsDefined"
      :count="params.value"
    />
  </div>
</template>

<script>

import Vue from 'vue'
import AttachmentCountBadge from '@/components/common/AttachmentCountBadge'

export default Vue.extend({
    name: 'AttachmentCountRenderer',
    components: {
        AttachmentCountBadge
    },
    computed: {
        valueIsDefined() {
            return this.params.value > 0
        }
    }
})

</script>
